import hellojs from '../../vendor/hello.js'

// generator to build driver config for a netdocs region
function buildNetDocumentsService(name, applicationUrl, apiUrl) {
  return {
    name: name,
    base: apiUrl,

    oauth: {
      version: 2,
      auth: `${applicationUrl}/neWeb2/OAuth.aspx`,
      grant: `${apiUrl}/v1/OAuth`,
      response_type: 'code',
    },

    login(p) {
      // sets popup size to fit NetDocuments login screen
      p.options.popup.width = 950;
      p.options.popup.height = 600;
    },

    // read – read all data the user has rights to access
    // edit - upload document content, create versions, check out, check in, change official version, create or modify document attachments
    // organize – create folders and saved searches, file items in folders, manipulate ACLs and profile values, manipulate favorite lists, home page, and recent docs lists, change folder parent
    // lookup – insert, update, and delete lookup table rows
    // delete_doc – delete documents
    // delete_container – delete folders, saved searches, filters, and workspaces
    // full – full access to all resources.  The application is allowed to do everything the user has rights to do.
    scope: {
      read: 'read',
      edit: 'edit',
      organize: 'organize',
      lookup: 'lookup',
      delete_doc: 'delete_doc',
      delete_container: 'delete_container',
      full: 'full',
    },

    scope_delim: ' ',
  }
}

const regionServiceNames = {
  US: 'netdocumentsUS',
  EU: 'netdocumentsEU',
  DE: 'netdocumentsDE',
  AU: 'netdocumentsAU',
}

export default function (region) {
  // throw exception or something if its not found?
  const serviceName = regionServiceNames[region];

  return hellojs
    // install NetDocuments driver
    .init({
      netdocumentsAU: buildNetDocumentsService(
        'netdocumentsAU',
        'https://au.netdocuments.com',
        'https://api.au.netdocuments.com',
      ),

      netdocumentsDE: buildNetDocumentsService(
        'netdocumentsDE',
        'https://de.netdocuments.com',
        'https://api.de.netdocuments.com',
      ),

      netdocumentsEU: buildNetDocumentsService(
        'netdocumentsEU',
        'https://eu.netdocuments.com',
        'https://api.eu.netdocuments.com',
      ),

      netdocumentsUS: buildNetDocumentsService(
        'netdocumentsUS',
        'https://vault.netvoyage.com',
        'https://api.vault.netvoyage.com',
      ),
    })
    .init(
      {
        netdocumentsAU: window.Drupal.settings.INTEGRATIONS_NETDOCS_AU_APP_ID,
        netdocumentsDE: window.Drupal.settings.INTEGRATIONS_NETDOCS_DE_APP_ID,
        netdocumentsEU: window.Drupal.settings.INTEGRATIONS_NETDOCS_EU_APP_ID,
        netdocumentsUS: window.Drupal.settings.INTEGRATIONS_NETDOCS_APP_ID,
      },
      {
        redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
        oauth_proxy: `${window.location.origin}/rpc/integrations/oauth_proxy`,
      }
    )
    (serviceName); // spawn instance that caller will call .login() on.
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/NetDocumentsAuthenticator.js